import "./Categories.css";
import React from "react";
import { BarLoader } from "react-spinners";
import { Box } from "@mui/material";
import TextFieldInput from "../../../Components/Atoms/Inputs/TextField/TextFieldInput";
import CategoryCard from "../../../Components/Molecules/Cards/CategoryCard/CategoryCard";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import AddIcon from "@mui/icons-material/Add";

function Categories({
  searchData,
  search,
  setSearchData,
  setSearch,
  navigate,
  loading,
  categories,
}) {
  return (
    <div className="mainContainer">
      <div className="cont">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <h2 style={{ fontSize: "24px" }}>
            Total Categories: {categories.length}
          </h2>
          <PrimaryButton
            classBtn={"center addButton"}
            text={"Add Category"}
            startIcon={<AddIcon />}
            style={{
              textTransform: "capitalize",
              borderRadius: "5px",
              color: "white",
              backgroundColor: "var(--primary)",
              height: "40px",
              padding: "0 30px",
              minWidth: "120px",
            }}
            click={() => {
              navigate("/categories/create");
            }}
          />
        </Box>
        {categories && !loading ? (
          <>
            {categories.length > 0 ? (
              <div className="categoriesGrid">
                {categories.map((category) => (
                  <CategoryCard key={category.id} category={category} />
                ))}
              </div>
            ) : (
              <h3 className="emptyMessage">No Categories Added Yet!!</h3>
            )}
          </>
        ) : (
          <div className="loadingBox">
            <BarLoader color="var(--primary)" />
          </div>
        )}
      </div>
    </div>
  );
}

export default Categories;
